var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 308,
    height: 308,
    viewBox: "0 0 308 308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_64_3524106",
    transform: "translate(-2.406 -2.406)",
    opacity: 0.336
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 154,
    cy: 154,
    r: 154,
    transform: "translate(2.406 2.406)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M241.588,99.619v7.219H202.606c-5.294,0-10.106,3.85-11.069,8.662s-6.256,8.662-11.069,8.662H102.987c-7.219,0-14.438,5.775-15.881,12.513L65.45,238.7a13.155,13.155,0,0,0,.962,7.7,21.45,21.45,0,0,1-3.85-12.512V78.925c0-10.106,6.737-18.287,14.919-18.287h54.381c5.294,0,9.144,5.294,9.144,11.55s4.331,11.55,9.144,11.55h77.481C235.331,83.256,241.588,90.475,241.588,99.619Z",
    fill: "#fcd66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M66.412,251.213a4.377,4.377,0,0,1-3.85-1.925c-3.369-4.331-4.812-9.625-4.812-15.4V78.925c0-12.994,8.662-23.1,19.731-23.1h54.381c7.7,0,13.956,7.219,13.956,16.363,0,3.85,2.406,6.737,4.331,6.737h77.481c10.106,0,18.287,9.625,18.287,21.175v7.219a4.547,4.547,0,0,1-4.812,4.813H202.125c-2.887,0-5.775,2.406-6.256,4.813-1.444,7.219-8.663,12.513-15.881,12.513h-77c-5.294,0-10.106,3.85-11.069,8.662L70.263,240.144a7.916,7.916,0,0,0,.481,4.813,4.582,4.582,0,0,1-1.444,6.256ZM77.481,64.969c-5.775,0-10.106,6.256-10.106,13.475V205.975l14.919-70.744c1.925-9.144,11.069-16.363,20.694-16.363h77.481c2.887,0,5.775-2.406,6.256-4.812,1.444-7.219,8.181-12.513,15.881-12.513h34.169V99.137c0-6.256-3.85-11.55-8.662-11.55H150.631c-7.7,0-13.956-7.219-13.956-16.362,0-3.85-1.925-6.738-4.331-6.738H77.481Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M269.019,120.794,243.994,238.7c-1.444,7.7-9.625,13.956-17.806,13.956H76.037a13.305,13.305,0,0,1-9.625-5.775c-1.444-2.406-1.444-4.812-.962-7.7L87.106,137.156c1.444-6.738,8.662-12.513,15.881-12.513h77.481c5.294,0,10.106-3.85,11.069-8.662s6.256-8.662,11.069-8.662h54.381C265.65,106.838,270.944,113.094,269.019,120.794Z",
    fill: "#76bfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M226.188,257.469H75.556a15.876,15.876,0,0,1-12.994-8.662,14.745,14.745,0,0,1-1.444-11.069L82.775,135.713c1.925-9.144,11.069-16.363,20.694-16.363H180.95c2.887,0,5.775-2.406,6.256-4.812,1.444-7.219,8.181-12.513,15.881-12.513h54.381c5.775,0,10.588,2.406,13.475,6.256s4.331,8.662,2.887,13.475h0L248.806,239.662C246.881,249.769,236.775,257.469,226.188,257.469Zm-123.2-128.494c-5.294,0-10.106,3.85-11.069,8.663L70.263,239.662a7.916,7.916,0,0,0,.481,4.813,6.124,6.124,0,0,0,5.775,3.369H226.188c5.775,0,12.031-4.812,13.475-10.106l25.025-117.906a7.462,7.462,0,0,0-.962-5.775,8.314,8.314,0,0,0-6.256-2.406H202.606c-2.887,0-5.775,2.406-6.256,4.813-1.444,7.219-8.662,12.512-15.881,12.512Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M154,213.194l-22.137-26.469-22.619,26.469V124.162H154Z",
    fill: "#e95c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M154,218.006a4.377,4.377,0,0,1-3.85-1.925l-18.769-22.137-18.769,22.619a5.431,5.431,0,0,1-5.294,1.444,4.622,4.622,0,0,1-3.369-4.331V124.162a4.547,4.547,0,0,1,4.813-4.812H154a4.547,4.547,0,0,1,4.813,4.813v89.031a4.622,4.622,0,0,1-3.369,4.331C155.444,218.006,154.963,218.006,154,218.006Zm-22.137-36.094a4.377,4.377,0,0,1,3.85,1.925L149.669,200.2V128.975H114.056V200.2l13.956-16.363A4.377,4.377,0,0,1,131.863,181.912Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCategory);
export default __webpack_public_path__ + "static/media/addCategory.4e8d6b2efbce08ddebd9ff41c31962cc.svg";
export { ForwardRef as ReactComponent };